import axios from "axios";

export default {
  namespaced: true,
  state: {
    loadingorders: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    loadingordersMessage: ''
  },
  mutations: {
    RECEIVED_LOADINGORDERS(state, payload) {
      state.loadingorders = payload;
      state.isReceiving = false;
    },
    RECEIVING_LOADINGORDERS(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },
    RECEIVING_LOADINGORDER(state) {
      state.isReceiving = true;
    },
    RECEIVED_LOADINGORDER(state, payload) {
      let find = state.loadingorders.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { loadingorders: [payload, ...state.loadingorders] });
      }
      else {
        let index = state.loadingorders.findIndex(x => x._id === payload._id);
        state.loadingorders.splice(index, 1, payload);
      }
    },

    UPDATED_LOADINGORDERS(state, payload) {
      console.log(state.loadingorders);
      console.log(payload);
      let index = state.loadingorders.findIndex(loadingorder => loadingorder._id === payload._id);
      state = Object.assign(state, {
        loadingorders: state.loadingorders.map((loadingorder, i) => {
          if (i === index) {
            return Object.assign({}, loadingorder, payload);
          }
          return loadingorder;
        }),
        isUpdating: false,
        loadingordersMessage: 'LoadingOrders has been updating!',
      })
    },
    UPDATING_LOADINGORDERS(state) {
      state.isUpdating = true;
    },
    DELETED_LOADINGORDERS(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.loadingorders.findIndex(loadingorder => loadingorder._id === payload._id);
      console.log(indexToDelete);
      let loadingorders = [...state.loadingorders];
      loadingorders.splice(indexToDelete, 1);
      state = Object.assign(state, {
        loadingorders: [...loadingorders],
        isDeleting: false,
        idToDelete: null,
        loadingordersMessage: 'LoadingOrder has been Deleted!',
      });
    },
    DELETING_LOADINGORDERS(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async runLoadingRequest({dispatch}, payload) {
      dispatch("receivingLoadingOrders");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/run/loading';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      var post = {method: "post",url: url, headers: headers, data: data};
      let response = await axios(post);
      dispatch("receiveLoadingOrder", response.data);
      return response.data;
    },
    async insertLoadingOrderRequest({dispatch}, payload) {
      dispatch("receivingLoadingOrders");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/loadingorder';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      var post = {method: "post",url: url, headers: headers, data: data};
      return axios(post)
      .then(response=> {dispatch("receiveLoadingOrder", response.data);})
      .catch((error) => {this.alertmessage = error;});	
    },
    async insertLOTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        delete payload['branditems'];
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/insert/lotransaction/" + payload.loadingorderid;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        console.log(response.data);
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    async deleteLoadingOrderRequest({dispatch}, payload) {
      dispatch("deletingLoadingOrder", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/loadingorder/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      let response = await axios({method: "delete", url: url, headers: headers});
      dispatch("deleteLoadingOrder", response.data);
      return response.data;
    },
    async deleteLOTransactionRequest({dispatch}, id) {
      try{
        dispatch("receivingTransactions");
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/delete/lotransaction/" + id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    async getLoadingOrdersRequest({dispatch}) {
      dispatch("receivingLoadingOrders");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/loadingorders';
      let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token };
      let get = { method: "get", url: url, headers: headers };
      return axios(get).then(response => {
        dispatch("receiveLoadingOrders", response.data);
      })
    },
    async getLoadingOrderRequest({dispatch}, id) {
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/loadingorder/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      let response = await axios({method: "get",url: url,headers: header});
      console.log('1',response.data)
      dispatch("receiveLoadingOrder", response.data);
      return response.data;
    },
    async findLoadingOrdersRequest({dispatch}, payload) {
      try{
        dispatch("receivingLoadingOrders");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/loadingorders';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveLoadingOrders", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateLoadingOrderRequest({dispatch}, payload) {
      dispatch("updatingLoadingOrder");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/loadingorder/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers,data: payload})
      .then((response)=> {
        dispatch("updateLoadingOrder", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateLOTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        var id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/update/lotransaction/" + id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "put", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    receiveLoadingOrders({commit}, payload) {
      commit("RECEIVED_LOADINGORDERS", payload)
    },
    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },
    receivingLoadingOrders({commit}) {
      commit("RECEIVING_LOADINGORDERS")
    },
    receiveLoadingOrder({commit}, payload) {
      commit("RECEIVED_LOADINGORDER", payload)
    },
    receivingLoadingOrder({commit}) {
      commit("RECEIVING_LOADINGORDERS")
    },
    updateLoadingOrder({commit}, payload) {
      commit("UPDATED_LOADINGORDERS", payload)
    },
    updatingLoadingOrder({commit}) {
      commit("UPDATING_LOADINGORDERS")
    },
    deleteLoadingOrder({commit}, payload) {
      commit("DELETED_LOADINGORDERS", payload)
    },
    deletingLoadingOrder({commit}, payload) {
      commit("DELETING_LOADINGORDERS", payload)
    }
  },
};
